import * as t from "io-ts";
const highlightsT = t.array(t.type({ start: t.number, end: t.number }));
export const autoSuggestResponseT = t.strict({
    items: t.array(t.strict({
        id: t.string,
        title: t.string,
        resultType: t.string,
        address: t.union([t.undefined, t.type({ label: t.string })]),
        highlights: t.type({
            title: highlightsT,
            address: t.union([
                t.undefined,
                t.type({
                    label: highlightsT,
                }),
            ]),
        }),
    })),
});
export const lookupT = t.strict({
    title: t.string,
    id: t.string,
    address: t.strict({
        label: t.string,
        countryCode: t.string,
        city: t.string,
        street: t.string,
        houseNumber: t.union([t.undefined, t.string]),
        postalCode: t.string,
    }),
    position: t.strict({
        lat: t.number,
        lng: t.number,
    }),
});
//# sourceMappingURL=io-ts-types.js.map